
import { defineComponent, computed } from "vue";
import { useModal } from "../utils/composable/useModal";
export default defineComponent({
  name: "Modal",
  setup(prp, ctx) {
    const { modal, hideModal } = useModal();

    const handleAcceptModal = () => {
      ctx.emit("modal-accepted");
      hideModal();
    };
    const handleCancelModal = () => {
      ctx.emit("modal-cancelled");
      hideModal();
    };

    const bannerInfo = [
      { type: "warning", label: "Błąd", color: "var(--red-100)" },
      { type: "success", label: "Sukces", color: "var(--green-100)" },
      { type: "question", label: "Pytanie", color: "var(--yellow-100)" },
      { type: "info", label: "Informacja", color: "var(--blue-300)" },
    ];

    const label = computed(() => {
      return (
        bannerInfo.find((item) => item.type === modal.type)?.label || "Błąd"
      );
    });

    const bannerColor = computed(() => {
      return (
        bannerInfo.find((item) => item.type === modal.type)?.color ||
        "var(--red-100)"
      );
    });

    return {
      handleAcceptModal,
      handleCancelModal,
      bannerColor,
      label,
      modal,
    };
  },
});
